var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"plusfriend-addfriend-button"}},[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip.left",value:({content: '카카오톡 문의하기', delay: {show: 500, hide: 100}}),expression:"{content: '카카오톡 문의하기', delay: {show: 500, hide: 100}}",modifiers:{"left":true}}],attrs:{"src":"/src/assets/dist/kakao.svg"},on:{"click":_vm.plusFriendChat}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fef7258","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/Kakao.vue
// module id = 418
// module chunks = 1